import { Client_Event_Name, Host_Event_Name } from '@quiz-buzz/common'
import {page_header_style, Standard_Page_Layout, sub_header_style} from '../Components/Standard_Page_Layout'
import { Button } from '../Components/Button'
import { Game_Results_Component } from '../Components/Game_Results_Component'
import { Rating } from 'react-simple-star-rating'
import { useState } from 'react'
import { Colours } from '../App/style/Colours'
import { style } from 'typestyle'
import { host_machine_actor } from '../App/main'
import { useSelector } from '@xstate/react'

export function Host_Game_Finished() {
	const send_close_game = () => host_machine_actor.send({type: Host_Event_Name.close_game})

	const { game_code, is_trial, round_num } = useSelector(host_machine_actor, (state) => state.context)

	const [usable_rating, set_usable_rating] = useState(0)
	const [problem_free_rating, set_problem_free_rating] = useState(0)
	const [looks_nice_rating, set_looks_nice_rating] = useState(0)
	const [feedback_comments, set_feedback_comments] = useState('')

	const send_feedback = () => {

		const feedback_event = {
			type: Client_Event_Name.send_feedback,
			detail: {
				client_name: 'web',
				user_type: 'host',
				game_code: game_code,
				is_trial: is_trial,
				rounds_played: round_num,
				usable_rating,
				problem_free_rating,
				looks_nice_rating,
				feedback_comments,
			},
		}
		fetch('/api/v1/feedback', {
			method: 'POST',
			body: JSON.stringify(feedback_event)
		})
	}

	const header = (
		<>
			<div className={page_header_style}>Finished</div>
			<div className={sub_header_style}>
				congratulations to the winner!
			</div>
		</>
	)
	const content = <div className={content_style}>
		<Game_Results_Component />
		<div>
			<h2>How would you rate this app?</h2>
			<div>
				<label className={feedback_label_style}>Usable?</label> <Rating emptyColor='#333' fillColor={Colours.neon_highlight} onClick={set_usable_rating}/>
			</div>
			<div>
				<label className={feedback_label_style}>Problem-free?</label> <Rating emptyColor='#333' fillColor={Colours.neon_highlight} onClick={set_problem_free_rating}/>
			</div>
			<div>
				<label className={feedback_label_style}>Looks nice?</label> <Rating emptyColor='#333' fillColor={Colours.neon_highlight} onClick={set_looks_nice_rating}/>
			</div>
			
			<input value={feedback_comments} onChange={(event) => set_feedback_comments(event.target.value)} placeholder="Any comments?" /><Button text="send" onClick={send_feedback} />
		</div>
		
	</div>

	const controls = (
		<div className='two_buttons'>
			<Button button_style="Primary" text="Close game" onClick={send_close_game} />
		</div>
	)
	return (
		<Standard_Page_Layout
			header={header}
			content={content}
			controls={controls}
		/>
	)
}

const feedback_label_style = style({
	display: 'inline-block',
	width: '12em'
})

const content_style = style({
	height: '100%',
	flexDirection: 'column',
	display: 'flex',
	justifyContent: 'space-between'
})